import Quota from './Quota';

export default Quota;
